module.exports = __webpack_public_path__ + "img/video-2.8345ba3a.png";